// AUTO-GENERATED SQL Builder (V40 Final) for WeddingCard
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class WeddingCardSql {
  private ast = new SqlAst('WeddingCard', 'weddingCard');
  public readonly main: any = {};

  public guid: SqlField;
  public bookingId: SqlField;
  public customerId: SqlField;
  public cardTemplateId: SqlField;
  public coupleNames: SqlField;
  public slug: SqlField;
  public eventDate: SqlField;
  public eventTime: SqlField;
  public eventSessionId: SqlField;
  public venueName: SqlField;
  public venueAddress: SqlField;
  public gpsLat: SqlField;
  public gpsLng: SqlField;
  public heroPhotoUrl: SqlField;
  public isPublished: SqlField;
  public configJson: SqlField;
  public status: SqlField;
  public booking: SqlNavHybrid;
  public cardTemplate: SqlNavHybrid;
  public createdByUser: SqlNavHybrid;
  public customer: SqlNavHybrid;
  public eventSession: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public cardRsvpList: SqlNavHybrid;
  public cardWishList: SqlNavHybrid;
  public checklistItemList: SqlNavHybrid;
  public checklistSectionList: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('weddingCard', 'guid', '', 'id', 'weddingCard_guid');
    this.bookingId = new SqlField('weddingCard', 'bookingId', 'booking', 'id', 'weddingCard_booking');
    this.customerId = new SqlField('weddingCard', 'customerId', 'customer', 'id', 'weddingCard_customer');
    this.cardTemplateId = new SqlField('weddingCard', 'cardTemplateId', 'cardTemplate', 'id', 'weddingCard_cardTemplate');
    this.coupleNames = new SqlField('weddingCard', 'coupleNames', '', 'id', 'weddingCard_coupleNames');
    this.slug = new SqlField('weddingCard', 'slug', '', 'id', 'weddingCard_slug');
    this.eventDate = new SqlField('weddingCard', 'eventDate', '', 'id', 'weddingCard_eventDate');
    this.eventTime = new SqlField('weddingCard', 'eventTime', '', 'id', 'weddingCard_eventTime');
    this.eventSessionId = new SqlField('weddingCard', 'eventSessionId', 'eventSession', 'id', 'weddingCard_eventSession');
    this.venueName = new SqlField('weddingCard', 'venueName', '', 'id', 'weddingCard_venueName');
    this.venueAddress = new SqlField('weddingCard', 'venueAddress', '', 'id', 'weddingCard_venueAddress');
    this.gpsLat = new SqlField('weddingCard', 'gpsLat', '', 'id', 'weddingCard_gpsLat');
    this.gpsLng = new SqlField('weddingCard', 'gpsLng', '', 'id', 'weddingCard_gpsLng');
    this.heroPhotoUrl = new SqlField('weddingCard', 'heroPhotoUrl', '', 'id', 'weddingCard_heroPhotoUrl');
    this.isPublished = new SqlField('weddingCard', 'isPublished', '', 'id', 'weddingCard_isPublished');
    this.configJson = new SqlField('weddingCard', 'configJson', '', 'id', 'weddingCard_configJson');
    this.status = new SqlField('weddingCard', 'status', '', 'id', 'weddingCard_status');
    this.booking = createNavHybrid('weddingCard', 'weddingCard_booking', 'Booking');
    this.cardTemplate = createNavHybrid('weddingCard', 'weddingCard_cardTemplate', 'CardTemplate');
    this.createdByUser = createNavHybrid('weddingCard', 'weddingCard_createdByUser', 'User');
    this.customer = createNavHybrid('weddingCard', 'weddingCard_customer', 'Customer');
    this.eventSession = createNavHybrid('weddingCard', 'weddingCard_eventSession', 'EventSession');
    this.updatedByUser = createNavHybrid('weddingCard', 'weddingCard_updatedByUser', 'User');
    this.cardRsvpList = createNavHybrid('weddingCard', 'weddingCard_cardRsvpList', 'CardRsvp');
    this.cardWishList = createNavHybrid('weddingCard', 'weddingCard_cardWishList', 'CardWish');
    this.checklistItemList = createNavHybrid('weddingCard', 'weddingCard_checklistItemList', 'ChecklistItem');
    this.checklistSectionList = createNavHybrid('weddingCard', 'weddingCard_checklistSectionList', 'ChecklistSection');
    this.id = new SqlField('weddingCard', 'id', '', 'id', 'weddingCard_id');
    this.isDeleted = new SqlField('weddingCard', 'isDeleted', '', 'id', 'weddingCard_isDeleted');
    this.createdBy = new SqlField('weddingCard', 'createdBy', '', 'id', 'weddingCard_createdBy');
    this.createdDate = new SqlField('weddingCard', 'createdDate', '', 'id', 'weddingCard_createdDate');
    this.updatedBy = new SqlField('weddingCard', 'updatedBy', '', 'id', 'weddingCard_updatedBy');
    this.updatedDate = new SqlField('weddingCard', 'updatedDate', '', 'id', 'weddingCard_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:WeddingCardSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:WeddingCardSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:WeddingCardSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:WeddingCardSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:WeddingCardSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:WeddingCardSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:WeddingCardSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:WeddingCardSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:WeddingCardSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:WeddingCardSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
